module.exports = __webpack_public_path__ + "static/media/Derwent Road 1.e34ab172.jpg";